exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-switch.s-lg.c-orange[data-v-4ffbdfe4]{width:125px;height:25px;padding-top:1px;background-color:#ff3860}.vue-switch.s-lg.z-on.c-orange[data-v-4ffbdfe4]:after{left:102px}.vue-switch.s-lg.c-orange span[data-v-4ffbdfe4]{color:#fff}.vue-switch[data-v-4ffbdfe4]:after{top:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ffbdfe4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inventario_Componentes/shared/SwitchArea.vue
// module id = 2161
// module chunks = 0